<template>
    <div class="text-left">
        <div class="checkbox-item">
            <input type="checkbox" class="check-style" id="mlb_opt_in" name="mlb_opt_in"
                v-model="mlb_opt_in"
                @change="onChange"
            />
            <label for="mlb_opt_in">
                I would like to receive commercial e-mails from
                <a class="text-success pointer" href="https://www.mlb.com/cubs" target="_blank">cubs.com</a>,
                <a class="text-success pointer" href="https://www.mlb.com/" target="_blank">MLB.com</a>
                and their partners.
            </label>&nbsp;
        </div>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'mlb-opt-in',
        data: function () {
            return this.getDefaultData();
        },
        methods: {
            getDefaultData: function () {
                // to provide original defaults only once
                return Object.assign({},
                    {
                        mlb_opt_in: false
                    },
                    this.$store.getters.marketing
                );
            },
            onChange: function(event) {
                this.$store.commit('updateMarketingInfo', this.$data);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// MlbOptIn.vue?61bffea4